import { format } from 'date-fns';
import { FileText } from 'lucide-react';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { ReleaseNote } from '@/types';

import { Button } from '@/components/ui/button';
import { RELEASE_NOTE_SHORT_DATE } from '@/utils/constants';
import { getDateFnsLocale } from '@/utils/helpers/get-date-fns-locale';

interface ReleaseNoteMenuFooterProps {
  release: ReleaseNote;
  onClick: () => void;
}

const ReleaseNoteMenuFooter: FC<ReleaseNoteMenuFooterProps> = ({ release, onClick }) => {
  const { t } = useTranslation();

  const { version, releaseDate } = release;

  const currentLocale = getDateFnsLocale();

  const formattedDate = format(new Date(releaseDate), RELEASE_NOTE_SHORT_DATE, {
    locale: currentLocale,
  });

  return (
    <Button variant="ghost" onClick={onClick} className="h-full w-full justify-between px-3 py-0">
      <span className="flex items-center gap-2">
        <FileText className="size-5" />
        <span className="font-normal">{t('menu.release_notes')}</span>
      </span>
      <span className="flex flex-col items-end text-xs text-muted-foreground font-normal">
        <span>{version}</span>
        <span>{formattedDate}</span>
      </span>
    </Button>
  );
};

export default ReleaseNoteMenuFooter;
